import { createStore } from 'redux'
import { combineReducers } from 'redux';


import checkIcon from './assets/icons/check.svg';
import errorIcon from './assets/icons/error.svg';
import infoIcon from './assets/icons/info.svg';
import warningIcon from './assets/icons/warning.svg';

const initialState = {
  sidebarShow: 'responsive'
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return {...state, ...rest }
    default:
      return state
  }
}

const user = (state = { currentUser: null }, action) => {
  switch (action.type) {
    case 'LOGIN_USER':
      return {...state, currentUser: action.payload}
    case 'LOGOUT_USER':
      return {...state, currentUser: null}
    default:
      return state;
  }
}

const getToast = (id, type, title, description) => {
  
  let toastProperties = {
    id,
    title,
    description,
  }
  switch(type) {
    case 'success':
      toastProperties = {
        ...toastProperties,
        backgroundColor: '#5cb85c',
        icon: checkIcon
      }
      break;
    case 'danger':
      toastProperties = {
        ...toastProperties,
        backgroundColor: '#d9534f',
        icon: errorIcon
      }
      break;
    case 'info':
      toastProperties = {
        ...toastProperties,
        backgroundColor: '#5bc0de',
        icon: infoIcon
      }
      break;
    case 'warning':
      toastProperties = {
        ...toastProperties,
        backgroundColor: '#f0ad4e',
        icon: warningIcon
      }
      break;
    default:
      break;
  }
  return toastProperties
}
const notification = (state = [], action) => {
  switch (action.type) {
    case 'DELETE_TOAST':
      return state.filter(toast => toast.id !== action.id);
    case 'ADD_TOAST':
      return [...state, getToast(state.length + 1, action.payload.type, action.payload.title, action.payload.description)]
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  changeState,
  user,
  notification
});

const store = createStore(rootReducer)
export default store